/**
 * Usuario que está atendiendo ahora (el que desbloqueó con PIN). Puede ser distinto del
 * dueño de la sesión cuando varios cajeros comparten el mismo equipo.
 */
import { createContext, useContext } from "react";

export const ActiveUserContext = createContext<string | null>(null);
export const useActiveUser = () => useContext(ActiveUserContext);
